export default "__VITE_ASSET__B_Hvu7fE__"